<footer>
  <p>
    Developed by
    <a
      href="https://www.linkedin.com/in/lcollares"
      target="_blank"
      rel="noopener noreferrer"
    >
      Leandro Collares
    </a>
    &middot; Source:
    <a
      href="https://www.nba.com/stats/"
      target="_blank"
      rel="noopener noreferrer"
    >
      NBA
    </a>
    &middot; Data downloaded on January 17, 2022
  </p>
</footer>

<style>
  footer {
    margin-top: 5px;
    max-width: 600px;
  }

  p {
    line-height: 25px;
  }

  a {
    color: #4427ca;
    text-decoration-thickness: 0.0625rem;
    text-underline-offset: 0.1em;
  }

  a:visited {
    color: #4427ca;
  }

  a:active {
    color: #dc267f;
    text-decoration-thickness: 0.2rem;
  }

  a:hover {
    color: #dc267f;
    text-decoration-thickness: 0.2rem;
  }
</style>
